export const COMMON_WEB_SOCKET_CONNECTION_MSG = 'COMMON_WEBSOCKET_CONNECTION_MSG';
